<template>
  <div class="container-fluid mt-4">
    <div>
      <h4>Logged out</h4>
      <span>You may close this window or sign in again <b-link to="/">here</b-link></span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);

export default {
  async created() {},

  methods: {},
};
</script>
